'use strict';

/**
 * Companies
 */
waApp.controllers.Companies = {
	add: function() {
		waUtils.postalCodeVsZipCode('#country-id', '#postal-code');
		waUtils.stateSelect('#country-id', '#state-id');

		waUtils.inputLanguageToggle();
	},
	edit: function() {
		waUtils.postalCodeVsZipCode('#country-id', '#postal-code');
		waUtils.stateSelect('#country-id', '#state-id');

		waUtils.inputLanguageToggle();
	}
};
